module.exports = __webpack_public_path__ + "static/img/fish14.35fb769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish14.png
// module id = DIeu
// module chunks = 0